import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/Login' // 登录页
import Panel from '@/views/Panel' // 主要面板
import ResourceList from '@/views/teachingResource/ResourceList'
import ResourcePreview from '@/views/teachingResource/ResourcePreview'
import Information from '@/views/Information' // 个人信息
import AnalyseList from '@/views/bookAnalyse/analyseList'
import AnalyseDetail from '@/views/bookAnalyse/analyseDetail'
import MicroList from '@/views/microClass/ResourceList'
import MicroDetail from '@/views/microClass/ResourcePreview'
import config from './config'

Vue.use(Router)
let title = '金太阳老师（测试版）'
if (config.env === 'production') {
  title = '金太阳老师'
}

const router = new Router({
  routes: [{
    path: '/',
    name: 'login',
    component: Login,
    meta: {
      title
    }
  }, {
    path: '/index',
    name: 'panel',
    component: Panel,
    meta: {
      title
    }
  }, {
    path: '/resource/list/:resourceTypeId/:categoryId/:resourceExtTypeId',
    name: 'resourceList',
    component: ResourceList,
    meta: {
      title,
      keepAlive: true
    }
  }, {
    path: '/resource/preview',
    name: 'resourcePreview',
    component: ResourcePreview,
    meta: {
      title
    }
  }, {
    path: '/information',
    name: 'information',
    component: Information,
    meta: {
      title
    }
  }, {
    path: '/analyse/list/:resourceTypeId/:categoryId/:resourceExtTypeId/',
    name: 'analyseList',
    component: AnalyseList,
    meta: {
      title,
      keepAlive: true
    }
  }, {
    path: '/analyse/detail',
    name: 'analyseDetail',
    component: AnalyseDetail,
    meta: {
      title
    }
  }, {
    path: '/microClass/list/:resourceTypeId/:categoryId/:resourceExtTypeId/',
    name: 'microList',
    component: MicroList,
    meta: {
      title,
      keepAlive: true
    }
  }, {
    path: '/microClass/detail',
    name: 'microDetail',
    component: MicroDetail,
    meta: {
      title
    }
  }]
})
// 路由守卫
router.beforeEach((to, from, next) => {
  const isLogin = !!localStorage.getItem('newAjaxHeader')
  const bookInfo = !!sessionStorage.getItem('userInfo')
  if (to.path === '/' || to.path === '/index') {
    next()
  } else {
    // 是否在登录状态下
    // isLogin ? (bookInfo ? next() : next('/index')) : next('/')
    next()
  }
})

export default router
